import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
// nodejs library that concatenates classes
import classNames from "classnames";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import CustomInput from '@app/components/CustomInput/CustomInput';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
// material-ui-core
import InputAdornment from "@material-ui/core/InputAdornment";
// icons
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const BusinessInvestmentView = (props) => {
    const classes = props.classes;
    // Validation messages
    // Business Investment
    const internalResourcesError = props.validationErrors.internalResources.show;
    const internalResourcesHelperText = props.validationErrors.internalResources.show ? props.validationErrors.internalResources.errorMessage : '';
    const externalResourcesError = props.validationErrors.externalResources.show;
    const externalResourcesHelperText = props.validationErrors.externalResources.show ? props.validationErrors.externalResources.errorMessage : '';
    const existingAssetsError = props.validationErrors.existingAssets.show;
    const existingAssetsHelperText = props.validationErrors.existingAssets.show ? props.validationErrors.existingAssets.errorMessage : '';
    // Options Messages
    return (
        <GridContainer justify='center'>
            <GridItem xs={12}>
                <form name="trading-online-voucher-scheme-2020" onSubmit={props.onSubmit}>    
                    <Card className={classes.cardSignUp}>
                        <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                            <h3 className={classNames(classes.cardTitle, classes.title)} id="businessInvestment">
                                BUSINESS INVESTMENT
                            </h3>
                        </CardHeader>
                        <CardBody className={classes.cardBodySignUp}>
                            <h4 className={classes.title} id="internalResources">
                                Internal Resources Brought To The Project&nbsp;
                                {props.validationErrors.internalResources.check === null ? ' ' : (props.validationErrors.internalResources.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>Examples of internal resources are:
                                                        <ul>
                                                            <li>Human or Financial Resources</li>
                                                            <li>Marketing Material</li>
                                                            <li>In-House Knowledge</li>
                                                            <li>Specific Expertise</li>
                                                            <li>Traffic To Your Current Website</li>
                                                        </ul>
                                                    </p>
                                                    <p>Does your partner help with your accounts?</p>
                                                    <p>Is your apprentice a star on TikTok?</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='internalResourcesInput'
                                        helperText={internalResourcesHelperText}
                                        error={internalResourcesError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'internalResources',
                                            value: props.internalResources,
                                            onChange: props.handleInternalResources,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'user-alt']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="externalResources">
                                External Resources Brought To The Project&nbsp;
                                {props.validationErrors.externalResources.check === null ? ' ' : (props.validationErrors.externalResources.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>This could be your supplier agreeing to allow you the use their product photos online or networking or association group memberships etc.</p>
                                                    <p> For example, being a Registered Electrical Contractor will enable you to be listed on the <a href="https://safeelectric.ie/find-an-electrician/" target="_blank" rel="noopener">SafeElectric website</a> for electricians. Having a link to your website on your RECI profile will boost your website's ranking on Google.</p>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='externalResourcesInput'
                                        helperText={externalResourcesHelperText}
                                        error={externalResourcesError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'externalResources',
                                            value: props.externalResources,
                                            onChange: props.handleExternalResources,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'user-ninja']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            <hr/>
                            <h4 className={classes.title} id="existingAssets">
                                Existing Assets The Project Should Leverage Off&nbsp;
                                {props.validationErrors.existingAssets.check === null ? ' ' : (props.validationErrors.existingAssets.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                            </h4>
                            <GridContainer justify='center'>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomAccordion
                                        active={1}
                                        activeColor="danger"
                                        collapses={[
                                            {
                                                title: "Help",
                                                content:
                                                <span>
                                                    <p>What additional information can you provide to help suppliers assist you?</p>
                                                    <p>Examples of existing assets are:</p>
                                                    <ul>
                                                        <li>Social media presence</li>
                                                        <li>Design material</li>
                                                        <li>Photographs</li>
                                                        <li>Brand & marketing material, e.g. logos, trade names, taglines.</li>
                                                    </ul>
                                                </span>
                                            }
                                        ]}
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={8}>
                                    <CustomInput
                                        id='existingAssetsInput'
                                        helperText={existingAssetsHelperText}
                                        error={existingAssetsError}
                                        formControlProps={{
                                            fullWidth: true
                                        }}
                                        inputProps={{
                                            multiline: true,
                                            rows: 6,
                                            name: 'existingAssets',
                                            value: props.existingAssets,
                                            onChange: props.handleExistingAssets,
                                            autoComplete: 'off',
                                            startAdornment: (
                                                <InputAdornment position='start'>
                                                    <FontAwesomeIcon icon={['fas', 'satellite']} className={classes.inputIconsColor} />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </GridItem>
                            </GridContainer>
                            </CardBody>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                    Main Menu
                                </Button>
                                <Button
                                    color="primary"
                                    size="sm"
                                    startIcon={<SaveIcon />}
                                    onClick={props.generateDoc}
                                >
                                    Download
                                </Button>
                            </div>
                        </CardFooter>
                        <CardFooter className={classes.cardFooterSignUp}>
                            <div className={classes.cardBodySignUpButtons}>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_PLAN}>
                                    &lt; Project Plan 
                                </Button>
                                <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_OUTCOMES}>
                                    Projected Outcomes &gt;
                                </Button>
                            </div>
                        </CardFooter>
                    </Card>
                </form>
            </GridItem>
        </GridContainer>
    );
}

BusinessInvestmentView.propTypes = {
    
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // Business Investment
    handleInternalResources: PropTypes.func.isRequired,
    handleExternalResources: PropTypes.func.isRequired,
    handleExistingAssets: PropTypes.func.isRequired,
    
    validationErrors: PropTypes.object.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(BusinessInvestmentView));